import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import "vue-swatches/dist/vue-swatches.min.css";
import "./plugins/vuetify";
// import I18n from "./components/internationalization/i18n";
// import I18nVueMixin from "./components/internationalization/i18n-mixin";
import App from "./App.vue";
import router from "./router";
import store from "./stores/store";
import GlobalService from "../src/services/global-service";
import {
  setUserInSessionStore,
  getSelectedLanguage,
  translate
} from "./common/HelperFunctions";
import {
  tempConvertFunc,
  onSliderTempConvertFunc,
  weightConvertFunc,
  dateFormat
} from "./common/Filters";
import * as VueGoogleMaps from "vue2-google-maps";
import { googleMapKey } from "./common/Constant";
import "./assets/GlobalStyles.css";
import LongPress from "vue-directive-long-press";
import VirtualList from 'vue-virtual-scroll-list'
import VueExcelEditor from 'vue-excel-editor'

Vue.use(VueExcelEditor)
Vue.component('virtual-list', VirtualList)

Vue.use(VueResource);
Vue.use(Vuex);
Vue.use(VueGoogleMaps, {
  load: {
    key: googleMapKey,
    libraries: "places" // necessary for places input
  }
});

Vue.config.productionTip = false;
window.selectedLang = {};
window.ukLang = {};
let language = getSelectedLanguage();
// window.I18n = new I18n(language ? language.lang : "uk");
// Vue.mixin(I18nVueMixin);
// window.selectedLang = GlobalService.getLang(language ? language.lang : "uk");
GlobalService.getLang(language ? language.lang : "uk").then(resp => {
  window.selectedLang = resp;
});
GlobalService.getLang("uk").then(resp => {
  window.ukLang = resp;
  new Vue({
    router,
    store: window.store,
    render: h => h(App)
  }).$mount("#app");
});

// vuex store initilization
if (!window.store) {
  window.store = new Vuex.Store(store);
}
setUserInSessionStore();

// bind filter functions to the app
Vue.filter("tempConversion", tempConvertFunc);
Vue.filter("onSliderTempConversion", onSliderTempConvertFunc);
Vue.filter("weightConversion", weightConvertFunc);
Vue.filter("formatDateString", dateFormat);
Vue.filter("translate", translate);

Vue.directive("long-press", LongPress);

// new Vue({
//   router,
//   store: window.store,
//   render: h => h(App)
// }).$mount("#app");
